export const notNull = (val) => !!val || 'must not be empty'
